import View from '@shared/components/layout-default/layout-default-router-view';

export const autoinformer = [
  {
    path: '/autoinformer',
    component: View,
    children: [
      {
        path: '',
        name: 'autoinformer.module',
        redirect: {
          name: 'autoinformer.campaign.index'
        }
      },
      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'autoinformer.stats.type',
            component: () =>
              import(
                /* webpackChunkName: 'autoinformer' */
                '@autoinformer/pages/campaigns-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      },
      {
        path: 'campaigns',
        component: View,
        children: [
          {
            path: '',
            name: 'autoinformer.campaign.index',
            meta: {
              title: { code: 'autoinformer.breadcrumb.campaign.index' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-list-page'
              )
          },
          {
            path: 'new',
            name: 'autoinformer.campaign.new',
            meta: {
              title: { code: 'autoinformer.breadcrumb.campaign.new' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-create-page'
              )
            // import(/* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-edit-page')
          },
          {
            path: ':id([\\d]*)/tasks',
            name: 'autoinformer.campaign.tasks',
            meta: {
              title: { code: 'autoinformer.breadcrumb.campaign.tasks' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-tasks-list-page'
              )
          },
          {
            path: ':id([\\d]*)/tasks/new',
            name: 'autoinformer.campaign.tasks.create',
            meta: {
              title: { code: 'autoinformer.breadcrumb.tasks.create' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-tasks-create-page'
              )
          },
          {
            path: ':id([\\d]*)/edit',
            name: 'autoinformer.campaign.edit',
            meta: {
              title: { code: 'autoinformer.breadcrumb.campaign.edit' },
              loadable: true
            },
            component: () =>
              import(
                /* webpackChunkName: "autoinformer" */ '@autoinformer/pages/campaigns-edit-page'
              )
          }
        ]
      }
    ],
    meta: {
      permissions: ['module_autocaller_is_allowed']
    }
  }
];
